// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventInjuriesGetBody = {
  eventId: string;
};

export type typeEventInjuriesGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    home: {
      teamId: string;
      injuries: {
        playerId: string;
        name: string;
        status: "out" | "doubtful" | "questionable" | "probable";
        note?: string | null;
      }[];
    };
    away: {
      teamId: string;
      injuries: {
        playerId: string;
        name: string;
        status: "out" | "doubtful" | "questionable" | "probable";
        note?: string | null;
      }[];
    };
  };
};

export type typeEventInjuriesGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventInjuriesGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventInjuriesGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventInjuriesGetBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventInjuriesGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventInjuriesGetBody);
  }

  return async function postEventInjuriesGet(
    payload: typeEventInjuriesGetBody,
  ): Promise<typeEventInjuriesGetOutput200 | typeEventInjuriesGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventInjuriesGet" failed before calling the network. #cd8b3e2c5577`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cd8b3e2c5577" },
        },
        data: null,
      } as typeEventInjuriesGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/injuries-get`,
      httpMethod: "POST",
      options,
    })) as typeEventInjuriesGetOutput200 | typeEventInjuriesGetOutput400;
  };
}
